import { useQueryStates } from 'src/core/api/hooks/useQueryStates';
import {
  isQuerySuccessState,
  reshapeQueryState,
  type QueryState,
} from 'src/core/api/queryState';
import { mapQueryResultToQueryState } from 'src/core/api/utils/queryState';
import { type RawSupplier } from 'src/core/modules/suppliers';
import { useFetchSuppliers } from 'src/core/modules/suppliers/hooks';

import { getDimensionValueIds } from '../helpers/budgetTree';
import { type BudgetTree } from '../models/budgetTree';

export const useBudgetSuppliers = (
  budgetQuery: QueryState<BudgetTree<unknown>>,
): QueryState<RawSupplier[]> => {
  const supplierIdsQuery = reshapeQueryState(budgetQuery, (budgetTree) =>
    Array.from(new Set(getDimensionValueIds(budgetTree, { type: 'supplier' }))),
  );

  const supplierIds = isQuerySuccessState(supplierIdsQuery)
    ? supplierIdsQuery.data
    : [];

  const suppliersQueryResult = useFetchSuppliers(supplierIds, {
    isEnabled: isQuerySuccessState(supplierIdsQuery),
  });

  const suppliersQueryState = useQueryStates({
    states: Object.fromEntries(
      suppliersQueryResult
        .map(mapQueryResultToQueryState)
        .map((queryState, index) => [index, queryState]),
    ),
  });

  return reshapeQueryState(suppliersQueryState, (suppliers) =>
    Object.values(suppliers),
  );
};
